import { Injectable } from '@angular/core';
import { IPaymentSourceService } from './ipayment-source.service';
import { PaymentSource } from './payment-source.model';
import { ApiService, ApiCacheOptions } from '../../../shared/index';
@Injectable({
  providedIn: 'root',
})
export class PaymentSourceService implements IPaymentSourceService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getPaymentSources = (): Promise<Array<PaymentSource>> => {
    return this._apiService.get('PaymentSources', this._cacheOptions).then((data: Array<PaymentSource>) => {
      return Promise.resolve(data);
    });
  };
}
